<template>
    <SelectAsync
        v-model="model"
        :searchFunction="search"
        :placeholder="placeholder"
        :hasError="hasError"
    >
        <template slot="option" slot-scope="props">
            <div v-if="props && props.option">
                <p class="text-xss mb-1">ID: {{ props.option.id }}</p>
                <template v-if="props.option.source.name">
                    <Icon :icon="getIcon(props.option.source_type)" />
                    <template v-if="props.option.source.name">
                        {{ props.option.source.name }}
                    </template>
                </template>
                <template
                    v-if="
                        props.option.creditable.name && props.option.source.name
                    "
                >
                    <span> to </span>
                </template>
                <template v-if="props.option.creditable.name">
                    <Icon :icon="getIcon(props.option.creditable_type)" />
                    <template v-if="props.option.creditable.name">
                        {{ props.option.creditable.name }}</template
                    >
                    <div class="mt-1 text-xxs">
                        <span v-if="props.option.name">{{
                            props.option.name
                        }}</span>
                        <span v-else>0 type defined</span>
                    </div>
                </template>
                <template
                    v-if="
                        !props.option.creditable.name ||
                        !props.option.source.name
                    "
                >
                    {{ props.option.name }}
                </template>
            </div>
        </template>
        <template slot="singleLabel" slot-scope="props">
            ({{ props.option.id }}) {{ props.option.name }}
        </template>
    </SelectAsync>
</template>

<script>
import ModelsSelects from "../../../mixins/ModelsSelects";

export default {
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "Select a wallet destination",
        },
    },
    methods: {
        defaultSearch(search) {
            return this.$api.wallets.get({
                search: search,
            });
        },
        getIcon(type) {
            if (type === "group") {
                return "building";
            }
            if (type === "user") {
                return "user";
            }
        },
    },
    mixins: [ModelsSelects],
};
</script>
